<template>
  <div class="heatmap-detailed">
    <div class="header project-header extra-top-padding">
      <div class="header-title wide-column">
        <div class="header-content">
          <div class="pre-title">
            <h3>
              Consignas Heatmap
            </h3>
          </div>
          <div class="title">
            <h1>{{ activityData.name }}</h1>
          </div>
        </div>
      </div>
      <div class="tabs-container">
        <div class="wide-column tabs">
          <ul>
            <li
              v-for="task in heatmapTasks"
              :key="task.identifier"
              :class="{ 'is-active': task.identifier === taskIdentifier }"
            >
              <localized-router-link
                v-if="heatmapTasks.length > 0"
                v-slot="{ href, navigate }"
                :to="getHeatmapDetailedLink(task)"
                custom
              >
                <a
                  :href="href"
                  @click="navigate"
                >
                  {{ task.title }}
                </a>
              </localized-router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tab-content">
      <b-loading
        v-if="loading"
        :is-full-page="true"
        :active="true"
      />
      <div
        v-else
        class="wide-column
        page-bottom-padding"
      >
        <div>
          <div
            v-for="responseData in heatmapData.taskResponses"
            :key="responseData.identifier"
            class="heatmap-chart"
          >
            <div class="heatmap-response-header">
              <h2>{{ responseData.authorDisplayName }}</h2>
            </div>
            <heatmap-response
              :task-response-pins="responseData.taskResponsePins"
              :task-data="heatmapTasks.find((task) => task.identifier === taskIdentifier)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import HeatmapResponse from '@/components/heatmap/HeatmapResponse.vue'
import { axiosBase, camelcaseTransformResponse } from '@/api/axios-base' // eslint-disable-line import/no-cycle
import sharedConstants from '@/shared/constants.json'

export default {
  name: 'HeatmapDetailed',
  components: {
    HeatmapResponse
  },
  data() {
    return {
      heatmapData: null,
      loading: true
    }
  },
  computed: {
    ...mapState('Projects', ['projectData']),
    ...mapState('summary', ['activityData']),
    heatmapTasks() {
      return this.activityData.tasks.filter((task) => task.taskType === sharedConstants.TASK_TYPE.HEATMAP)
    },
    taskIdentifier() {
      return this.$route.params.taskIdentifier
    }
  },
  watch: {
    async taskIdentifier() {
      this.loading = true

      await this.getHeatmapData()

      this.loading = false
    }
  },
  async created() {
    this.loading = true

    await this.getHeatmapData()

    this.loading = false
  },
  methods: {
    async getHeatmapData() {
      const projectIdentifier = this.projectData.identifier
      const activityIdentifier = this.activityData.identifier

      const response = await axiosBase.get(
        `/projects/${projectIdentifier}/activities/${activityIdentifier}/tasks/${this.taskIdentifier}/heatmap_data/`,
        {
          // TODO: transform request and response globally on all Axios requests
          transformResponse: [camelcaseTransformResponse, ...axiosBase.defaults.transformResponse]
        }
      )

      this.heatmapData = response.data
    },
    getHeatmapDetailedLink(taskData) {
      return {
        name: 'heatmap-report',
        params: {
          taskIdentifier: taskData.identifier
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../../scss/project_dashboard.scss';
</style>

<style lang="scss" scoped>
h2.task-title {
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 26px;
}

.heatmap-response-header {
  h2 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
  }
}

.heatmap-chart:not(:last-child) {
  margin-bottom: 30px;
}

@media print {
  .heatmap-chart {
    break-inside: avoid;
  }
}
</style>
